module.exports = __webpack_public_path__ + "img/dollar-coin.d74786a3.svg";